import { useRouter } from 'next/navigation'

interface EPayRedirectProps {
  paymentUrl: string
  onError?: (error: any) => void
}

export const useEPayRedirect = () => {
  const router = useRouter()

  const redirectToEPay = ({ paymentUrl, onError }: EPayRedirectProps) => {
    try {
      if (!paymentUrl) {
        throw new Error('Payment URL is required')
      }

      // Redirect to EPAY payment page
      window.location.href = paymentUrl
    } catch (error) {
      console.error('Error redirecting to EPAY:', error)
      onError?.(error)
    }
  }

  return { redirectToEPay }
}
